import React, { FC, useEffect, useState } from 'react'
import { Outlet } from 'react-router'

import useDarkMode from '@hooks/use-dark-mode'

import { cn } from '@lib/utils'
import { SidebarProvider } from '@components/ui/sidebar'
import PageSidebar from './sidebar'
import { SessionProvider } from '@context/sessions'
import { SessionClaims } from '@gen/api/v1/api_pb'
import { useMutation } from '@connectrpc/connect-query'
import { refresh, whoami } from '@gen/api/v1/api-ApiService_connectquery'
import { getAccessToken, setAccessToken, shouldRefresh } from '@lib/auth'

interface PageProps {
  hideSidebar?: boolean
}

const Page: FC<PageProps> = ({ hideSidebar = false }) => {
  const darkMode = useDarkMode()
  const refreshMutation = useMutation(refresh)
  const whoamiMutation = useMutation(whoami)

  const [session, setSession] = useState<SessionClaims | undefined>(undefined)

  useEffect(() => {
    ;(async () => {
      const accessToken = getAccessToken()
      if (!accessToken || (accessToken && shouldRefresh(accessToken))) {
        const { accessToken } = await refreshMutation.mutateAsync({})
        if (accessToken) {
          setAccessToken(accessToken)
        }
      }

      const whoamiRes = await whoamiMutation.mutateAsync({})
      if (whoamiRes?.sessionClaims) {
        setSession(whoamiRes.sessionClaims)
      }
    })()
  }, [])

  return (
    <div className={cn(darkMode ? 'dark' : '')}>
      <SessionProvider value={session}>
        <SidebarProvider>
          {!hideSidebar && <PageSidebar />}
          <main className="w-screen min-h-screen bg-background text-foreground p-4">
            <Outlet />
          </main>
        </SidebarProvider>
      </SessionProvider>
    </div>
  )
}

export default Page
